import React, { Component } from 'react';
import { Helmet } from "react-helmet";
import PropTypes from 'prop-types';
import ShowbizPreviewHeader from './showbiz/showbiz-preview-header';
import renderPenname from './utils/renderPenname';
const ShowbizTypeNormal = (props) => {

  const {
    postContent: {
      title,
      description,
      content,
      categories,
      contentpenname,
      tags
    },
    postContent
  } = props;

  const post = postContent;

  return (
    <React.Fragment>

      <ShowbizPreviewHeader />

      <main className="position-relative">
        <div className="container">

          <div className="entry-header entry-header-3 mb-50 text-center text-white">
            <div className="thumb-overlay img-hover-slide border-radius-5 position-relative" style={{ backgroundImage: `url(${post.img_hor})` }}>
              <div className="position-midded">
                <div className="entry-meta meta-0 font-small mb-30">
                  {post.primary_category &&
                  <a href={`/${post.primary_category.slug}`}>
                    <span className="post-cat bg-success color-white">{post.primary_category.name}</span>
                  </a>
                  }
                </div>

                <h1 className="post-title mb-30 text-white">
                  {post.title}
                </h1>
                {post.contentpenname &&
                <div className="entry-meta meta-1 color-grey text-uppercase text-white">
                  <span className="post-by text-white">{renderPenname(post.contentpenname)}</span>

                </div>
                }
              </div>
            </div>
          </div>

          <div className="row mb-50">
            <div className="col-lg-2 d-none d-lg-block"></div>
            <div className="col-lg-8 col-md-12">
              <div className="single-social-share single-sidebar-share mt-30">
                <ul>
                  <li >
                    <a className="social-icon facebook-icon text-xs-center"  rel="noreferrer" title="Share on Facebook">
                      <i className="ti-facebook"></i>
                    </a>
                  </li>

                </ul>
              </div>
              <div className="single-excerpt">
                <p className="font-large">{post.description}</p>
              </div>
              <div
                itemProp="articleBody"
                className="entry-main-content"
                dangerouslySetInnerHTML={{ __html: post.content }}
              />

              <div className="entry-bottom mt-50 mb-30">
                {/* <div className="font-weight-500 entry-meta meta-1 font-x-small color-grey">
                  <span className="update-on"><i className="ti ti-reload mr-5"></i>Updated 18/09/2020 10:28 EST</span>
                  <span className="hit-count"><i className="ti-comment"></i>82 comments</span>
                  <span className="hit-count"><i className="ti-heart"></i>68 likes</span>
                  <span className="hit-count"><i className="ti-star"></i>8/10</span>
                </div> */}
                <div className="overflow-hidden mt-30 d-flex justify-content-between">
                  <div className="tags float-left text-muted mb-md-30">
                    <span className="font-small mr-10"><i className="fa fa-tag mr-5"></i>Tags: </span>
                    {post.tags && post.tags.map((tag, idx) =>
                      <a href={`/tag/${tag.slug}`} prefetch="false" key={`art-tag-${idx}`} rel="tag">{tag.label}</a>
                    )}
                  </div>
                  <div className="single-social-share float-right">
                    <ul className="d-inline-block list-inline">
                      <li className="list-inline-item"><span className="font-small text-muted"><i className="ti-sharethis mr-5"></i>Share: </span></li>

                      <li className="list-inline-item">
                        <a className="social-icon facebook-icon text-xs-center mb-0"  title="Share on Facebook">
                          <i className="ti-facebook"></i>
                        </a>
                      </li>

                    </ul>
                  </div>
                </div>
              </div>

            </div>
          </div>

         
        </div>
      </main>

    </React.Fragment>
  );
}


ShowbizTypeNormal.propTypes = {
  postContent: PropTypes.object
};


export default ShowbizTypeNormal;
